import { Option } from './optionSelect'

export type DiscoveryStatus = 'DRAFT' | 'PUBLISHED' | 'HIDDEN'
export type ProfileClaimStatus = 'UNCLAIMED' | 'CLAIM_PENDING' | 'VERIFIED'
export type VisualAssetStatus =
  | 'NONE'
  | 'PENDING_REVIEW'
  | 'VERIFIED'
  | 'REJECTED'
export type CoverAssetStatus = VisualAssetStatus
export type PlaybackStatus = 'DISABLED' | 'INTERNAL_ONLY' | 'ENABLED'

export type CatalogGovernanceValue =
  | DiscoveryStatus
  | ProfileClaimStatus
  | VisualAssetStatus
  | PlaybackStatus

export const discoveryStatusOptions: Option[] = [
  { value: 'DRAFT', label: 'Draft' },
  { value: 'PUBLISHED', label: 'Published' },
  { value: 'HIDDEN', label: 'Hidden' },
]

export const profileClaimStatusOptions: Option[] = [
  { value: 'UNCLAIMED', label: 'Unclaimed' },
  { value: 'CLAIM_PENDING', label: 'Claim Pending' },
  { value: 'VERIFIED', label: 'Verified' },
]

export const visualAssetStatusOptions: Option[] = [
  { value: 'NONE', label: 'None' },
  { value: 'PENDING_REVIEW', label: 'Pending Review' },
  { value: 'VERIFIED', label: 'Verified' },
  { value: 'REJECTED', label: 'Rejected' },
]

export const coverAssetStatusOptions = visualAssetStatusOptions

export const playbackStatusOptions: Option[] = [
  { value: 'DISABLED', label: 'Disabled' },
  { value: 'INTERNAL_ONLY', label: 'Internal Only' },
  { value: 'ENABLED', label: 'Enabled' },
]

const governanceLabels: Record<CatalogGovernanceValue, string> = {
  DRAFT: 'Draft',
  PUBLISHED: 'Published',
  HIDDEN: 'Hidden',
  UNCLAIMED: 'Unclaimed',
  CLAIM_PENDING: 'Claim Pending',
  VERIFIED: 'Verified',
  NONE: 'None',
  PENDING_REVIEW: 'Pending Review',
  REJECTED: 'Rejected',
  DISABLED: 'Disabled',
  INTERNAL_ONLY: 'Internal Only',
  ENABLED: 'Enabled',
}

export function formatGovernanceValue(value?: CatalogGovernanceValue | null) {
  if (!value) return 'Unknown'

  return governanceLabels[value] ?? value
}
